import { Box, Stack, Typography } from "@mui/material";
import type {
  FacilityTerminalDto,
  TerminalItemDto,
} from "Infrastructure/Api/Api";
import { TerminalRow } from "Components/Merchants/OrbitLOnboarding/TerminalRow";

type Props = {
  facility: FacilityTerminalDto;
  onSwapClick: (terminal: TerminalItemDto) => void;
};

export const FacilityTerminals = ({ facility, onSwapClick }: Props) => (
  <Box>
    <Typography variant="body2" fontWeight={500} gutterBottom>
      {facility.facilityName ?? "—"}
      {facility.facilityAddress && (
        <Typography
          component="span"
          variant="body2"
          color="text.secondary"
          ml={1}
        >
          {facility.facilityAddress}
        </Typography>
      )}
    </Typography>
    <Stack component="ul" sx={{ m: 0, pl: 3 }} gap={0.5}>
      {facility.terminals.map((terminal) => (
        <TerminalRow
          key={terminal.publicID ?? terminal.serialNumber}
          terminal={terminal}
          onSwapClick={onSwapClick}
        />
      ))}
    </Stack>
  </Box>
);
